module.exports = __webpack_public_path__ + "img/magnify.f394a126.webp";